import { useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { Navigate } from "react-router-dom";

import {
  Card,
  CardContent,
  CardHeader,
  // CardActions,
  Typography,
  TextField,
  Button,
  IconButton,
  Stack,
  Alert,
  InputAdornment,
  Box,
} from "@mui/material";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import { buildInfo } from "@/lib/buildInfo";

export default function LoginPage() {
  const { user, loginUser } = useAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(false);

  if (user) return <Navigate to="/search" replace />;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(false);

    const ok = await loginUser(username, password);
    if (!ok) setError(true);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "grey.100",
        p: 2,
      }}
    >
      <Card sx={{ width: "100%", maxWidth: 420, borderRadius: 3, boxShadow: 4 }}>
        <CardHeader
          sx={{ textAlign: "center" }}
          title={
            <>
              <Box sx={{ width: 96, height: 96, mx: "auto", mb: 1 }}>
                <img
                  src="/artwork/window-pure.jpg"
                  alt="Canvass for Pure Window"
                  width="96"
                  height="96"
                  style={{ objectFit: "contain" }}
                />
              </Box>
              <Typography variant="h5" component="div" fontWeight={600}>
                Pure Canvass Login
              </Typography>
            </>
          }
        />

        <CardContent>
          <form onSubmit={submit}>
            <Stack spacing={2} mt={1}>
              {error && (
                <Alert severity="error">Invalid username or password</Alert>
              )}

              <TextField
                label="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck={false}
                slotProps={{ htmlInput: {     autoCapitalize: "none",
                autoCorrect: "off",
                spellCheck: false, } }}
                fullWidth
              />

              <TextField
                label="Password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword((v) => !v)}
                        edge="end"
                        size="small"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                type="submit"
                variant="contained"
                size="large"
                sx={{ py: 1.2 }}
                fullWidth
              >
                Login
              </Button>

              <Typography
                variant="caption"
                color="text.secondary"
                align="center"
                sx={{ mt: 1 }}
              >
                {buildInfo.label}
              </Typography>
            </Stack>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
